import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

// import { OktaAuth, IDToken, AccessToken } from '@okta/okta-auth-js';
import { Router } from '@angular/router';
import { AccessToken, IDToken, OktaAuth } from '@okta/okta-auth-js';
import { SeguridadUsuarioService } from '../seguridad/seguridad-usuario.service';
import { SessionModel } from 'src/app/models/seguridad/SesionModel';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class OktaAuthService {
//ENGIE
  CLIENT_ID = '0oa6cdgthh9SeWkdC0i7';
  ISSUER = 'https://engie.okta-emea.com/oauth2/default';
  LOGIN_REDIRECT_URI = 'https://gestiondocumental-contratistas.engie-energia.pe/callback';
  LOGOUT_REDIRECT_URI = 'https://gestiondocumental-contratistas.engie-energia.pe/';
//DEV
  // CLIENT_ID = '0oa1in777dtZCyNkZ5d7';
  // ISSUER = 'https://dev-42553877.okta.com/oauth2/default';
  // LOGIN_REDIRECT_URI = 'http://localhost:4200/callback';
  // LOGOUT_REDIRECT_URI = 'http://localhost:4200/';

  oktaAuth = new OktaAuth({
    clientId: this.CLIENT_ID,
    issuer: this.ISSUER,
    redirectUri: this.LOGIN_REDIRECT_URI,
    pkce: true
  });

  $isAuthenticated: Observable<boolean>;
  private observer?: Observer<boolean>;

  $userName: Observable<string>;
  private observerUserName?: Observer<string>;
  
  constructor(
    private router: Router,
    private seguridadUsuarioService: SeguridadUsuarioService,
    private storageService: StorageService,
    ) {
    this.$isAuthenticated = new Observable((observer: Observer<boolean>) => {
      this.observer = observer;
      this.isAuthenticated().then(val => {
        observer.next(val);
      });
    });

    this.$userName = new Observable((observer: Observer<string>) => {
      this.observerUserName = observer;
      this.getUser().then(val => {
        observer.next(val);
      });
    });
  }

  async isAuthenticated() {
    // Checks if there is a current accessToken in the TokenManger.
    return !!(await this.oktaAuth.tokenManager.get('accessToken'));
  }


  async getUser(): Promise<string> {
    const userClaims = await this.oktaAuth.getUser();

    // console.log(this.oktaAuth.getAccessToken());

    console.log(userClaims);
    if(userClaims.name)
      return userClaims.name;
    else
      return '';
  }

  getAccessToken(): string {
    const accessToken = this.oktaAuth.getAccessToken();

    if(accessToken)
      return accessToken;
    else
      return '';
  }

  login(originalUrl: string) {
    // Save current URL before redirect
    sessionStorage.setItem('okta-app-url', originalUrl || this.router.url);

    // Launches the login redirect.
    this.oktaAuth.token.getWithRedirect({
      scopes: ['openid', 'email', 'profile']
    });
  }

  async handleAuthentication() {
    const tokenContainer = await this.oktaAuth.token.parseFromUrl();

    this.oktaAuth.tokenManager.add('idToken', tokenContainer.tokens.idToken as IDToken);
    this.oktaAuth.tokenManager.add('accessToken', tokenContainer.tokens.accessToken as AccessToken);
    // console.log(tokenContainer.tokens.accessToken);

    const userClaims = await this.oktaAuth.getUser();

    

    if (await this.isAuthenticated()) {
      // console.log('autenticado');

      var q = await this.seguridadUsuarioService.getCurrent().toPromise();

      let session: SessionModel = new SessionModel();
        // session.token = p.accessToken;
        
      if(tokenContainer.tokens.accessToken)
        session.token = tokenContainer.tokens.accessToken?.accessToken;

      session.user = q;
      session.user.isLogged = true;

      // user name is exposed directly as property
      // console.log(userClaims);
      if(userClaims.given_name)
        session.user.nombres = userClaims.given_name; //user

      if(userClaims.family_name)
        session.user.apellidos = userClaims.family_name; //user

      this.storageService.setCurrentSession(session);
        // // this.router.navigate(['/']);
        // this.router.navigateByUrl(this.returnUrl);

      this.observer?.next(true);
      this.observerUserName?.next('');
    }

    // Retrieve the saved URL and navigate back
    const url = sessionStorage.getItem('okta-app-url') as string;
    this.router.navigateByUrl(url);
  }

  async logout() {
    await this.oktaAuth.signOut({
      postLogoutRedirectUri: this.LOGOUT_REDIRECT_URI
    });
  }
}
